import { render, staticRenderFns } from "./boxSum.vue?vue&type=template&id=5afeb853&scoped=true&"
import script from "./boxSum.vue?vue&type=script&lang=js&"
export * from "./boxSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afeb853",
  null
  
)

export default component.exports